const Arrow = ({placement, centerX, centerY, offset}) => {
    const size = 8
    const base = {position: 'absolute', width: 0, height: 0, borderStyle: 'solid'}
    const dx = (offset && offset.x) || 0
    const dy = (offset && offset.y) || 0
    if (placement === 'top')
        return (
            <span
                style={{
                    ...base,
                    bottom: -size,
                    // left: '50%',
                    // transform: 'translateX(-50%)',
                    left: centerX != null ? centerX + dx : '50%',
                    transform: 'translateX(-50%)',
                    borderWidth: `${size}px ${size}px 0 ${size}px`,
                    borderColor: '#fff transparent transparent transparent',
                }}
            />
        )
    if (placement === 'bottom')
        return (
            <span
                style={{
                    ...base,
                    top: -size,
                    // left: '50%',
                    // transform: 'translateX(-50%)',
                    left: centerX != null ? centerX + dx : '50%',
                    transform: 'translateX(-50%)',
                    borderWidth: `0 ${size}px ${size}px ${size}px`,
                    borderColor: 'transparent transparent #fff transparent',
                }}
            />
        )
    if (placement === 'left')
        return (
            <span
                style={{
                    ...base,
                    right: -size,
                    // top: '50%',
                    // transform: 'translateY(-50%)',
                    top: centerY != null ? centerY + dy : '50%',
                    transform: 'translateY(-50%)',
                    borderWidth: `${size}px 0 ${size}px ${size}px`,
                    borderColor: 'transparent transparent transparent #fff',
                }}
            />
        )
    if (placement === 'right')
        return (
            <span
                style={{
                    ...base,
                    left: -size,
                    // top: '50%',
                    // transform: 'translateY(-50%)',
                    top: centerY != null ? centerY + dy : '50%',
                    transform: 'translateY(-50%)',
                    borderWidth: `${size}px ${size}px ${size}px 0`,
                    borderColor: 'transparent #fff transparent transparent',
                }}
            />
        )
    return null
}

export default Arrow
